// extracted by css-extract-rspack-plugin
export default {"cls1":"SingleClaimPage-cls1_hvq","cls2":"SingleClaimPage-cls2_RKn SingleClaimPage-cls1_hvq"};